import $ from 'jquery';
import {MobileNavigation} from './MobileNavigation';
import activateFocusTrap from '../utils/focusTrap';

const MOBILE_BREAKPOINT = 992;
const CONFIG = {
    anchoreOffsetTop: 70
};

/**
 * Controls navigation functionality
 */
export class Navigation {

    /**
     *
     * @param {string|HTMLElement|jQuery} navigationRootElement
     */
    constructor(navigationRootElement) {

        if (!navigationRootElement) {
            throw new Error('Navigation root element must be specified');
        }

        /**
         *
         * @type {jQuery}
         */
        this.$root = $(navigationRootElement);

        /**
         *
         * @type {jQuery}
         */
        this.$header = this.$root.closest('.ar-header');

        /**
         *
         * @type {jQuery}
         */
        this.$searchBtn = this.$header.find('.ar-nav-search-btn');

        /**
         *
         * @type {jQuery}
         */
        this.$searchBtnWrapper = this.$header.find('.ar-nav-search-wrap');

        /**
         *
         * @type {ClientRect}
         */
        this.headerClientRect = undefined;

        /**
         * @type {MobileNavigation}
         */
        this.mobileNav = undefined;

        this.deactivateFocusTrap = undefined;

        this.init();
    }

    /**
     *
     */
    init() {
        this.myArtemisDropdown(); //TODO: This shouldn't be in this file!
        if(!this.$header.length) return;

        //Numbering is not longer desired.
        //this.topLevelLinkNumbering();
        this.topLevelSubMenuIndicator();
        this.keyboardNavigation();

        this.mobileNav = MobileNavigation.create();

        this.initEvents();

        this.onWindowResize();

        this.closeFocusedSelectDropdown();

        this.scrollToAnchorPosition();
    }

    closeFocusedSelectDropdown() {
        // close any opened native select to avoid hiding menu items under options of the select (native select bug on windows)
        this.$root.on("mouseenter", function (e) {
            $(document).find('.ar-custom-select select:focus').trigger('blur');
        })
    }

    initEvents(){
        $(window)
            .on('resize', _.throttle(this.onWindowResize.bind(this), 150))
            .on('scroll', _.throttle(this.onScroll.bind(this), 50, {leading: true}));
    }

    /**
    *
    */

    scrollToAnchorPosition() {
        if(window.location.hash.length > 0 && window.location.hash !== "#sessionrestored" && $('[name='+window.location.hash.replace('#','')+']').offset()) {
            window.scrollTo(0, $('[name='+window.location.hash.replace('#','')+']').offset().top - CONFIG.anchoreOffsetTop);
        }
    }

    /**
     *
     */
    topLevelSubMenuIndicator() {
        var links = this.$root.find('> ul li').filter(':has(> ul)');

        links.addClass('has-children');
    }

    /**
     *
     */
    topLevelLinkNumbering() {
        var anchors = this.$root.find('> ul > li > a');

        anchors.each(function (i, element) {
            $(this).prepend($(document.createElement('span')).text(Number(i + 1).toFixed(1)).addClass('nav-count'));
        });
    }

    /**
     *
     */
    keyboardNavigation() {
        const allAnchors = this.$root.find('a');
        const expandableAnchors = this.$root.find('li.has-children > a');

        let isOutsideFocusHandlerEnabled = false;
        const outsideFocusHandler =(e) => {
            if (this.$root[0].contains(e.target)) return;
            this.$root.find('li.open').removeClass('open');
            setOutsideFocusHandler(false);
        };
        const setOutsideFocusHandler = (enabled) => {
            if (enabled === isOutsideFocusHandlerEnabled) return;

            isOutsideFocusHandlerEnabled = enabled;
            
            if (enabled) {
                $(document).on('click focusin', outsideFocusHandler);
            } else {
                $(document).off('click focusin', outsideFocusHandler);
            }
        };

        expandableAnchors.on('keydown', (e) => {
            if (e.which === 32) {
                $(e.currentTarget).parent('li').toggleClass('open');
                e.preventDefault();
                e.stopImmediatePropagation();
                setOutsideFocusHandler(this.$root.find('li.open').length !== 0);
                return false;
            }
        });

        // Close open submenus as the user tabs out of them
        allAnchors.on('focus', (e) => {
            const openedItems = $(e.currentTarget)
                .closest('li')
                .parentsUntil('.ar-header-primary-nav', 'li')
                .addClass('open');
            const openedItemsSet = new Set(openedItems);
            
            this.$root.find('li.open').filter((_i, element) => !openedItemsSet.has(element)).removeClass('open');
            setOutsideFocusHandler(true);
        });
    }

    /**
     *
     * @param {jQuery.Event} e
     */
    onWindowResize(e) {
        this.headerClientRect = this.$header[0].getBoundingClientRect();
        this.onScroll();
    }


    /**
     *
     * @param {jQuery.Event} e
     */
    onScroll(e) {
        if (this.navigationAnimationInProgress || this.headerClientRect.width < MOBILE_BREAKPOINT) {
            return;
        }

        if (window.pageYOffset > this.headerClientRect.height && !this.fixedMode) {
            this.navigationAnimationInProgress = true;

            this.fixedMode = true;
            this.$header.addClass('ar-fixed-menu');

            document.querySelector(':root').style.setProperty('--header-height', `${this.headerClientRect.height}px`);

            this.$header[0].style.transform = `translate3d(0,-${this.headerClientRect.height}px,0)`;
            this.$header[0].style['-webkit-transform'] = `translate3d(0,-${this.headerClientRect.height}px,0)`;

            var a = this.$header[0].getBoundingClientRect();

            this.$header.addClass('animate-on-transforms');

            //Play animation
            this.$header[0].style.transform = `translate3d(0,0,0)`;
            this.$header[0].style['-webkit-transform'] = `translate3d(0,0,0)`;

            setTimeout(()=> {
                this.$header.removeClass('animate-on-transforms');
                this.navigationAnimationInProgress = false;
                this.headerClientRect = this.$header[0].getBoundingClientRect();

            }, 200);
        }
        if (window.pageYOffset <= this.headerClientRect.height && this.fixedMode) {
            this.navigationAnimationInProgress = true;
            this.fixedMode = false;

            this.$header[0].style.top = '-' + this.headerClientRect.height + 'px';

            this.$header[0].style.transform = `translate3d(0,${this.headerClientRect.height}px,0)`;
            this.$header[0].style['-webkit-transform'] = `translate3d(0,${this.headerClientRect.height}px,0)`;

            this.headerClientRect = this.$header[0].getBoundingClientRect();


            requestAnimationFrame(() => {
                //Play animation
                this.$header.addClass('animate-on-transforms');
                this.$header[0].style.transform = `translate3d(0,0,0)`;
                this.$header[0].style['-webkit-transform'] = `translate3d(0,0,0)`;

                setTimeout(()=> {
                    this.$header.removeClass('animate-on-transforms');
                    this.$header[0].style.top = '0px';
                    this.$header.removeClass('ar-fixed-menu');
                    document.querySelector(':root').style.setProperty('--header-height', null);

                    this.$header[0].style.transform = `translate3d(0,-${this.headerClientRect.height + 20}px,0)`;
                    this.$header[0].style['-webkit-transform'] = `translate3d(0,-${this.headerClientRect.height + 20}px,0)`;

                    this.headerClientRect = this.$header[0].getBoundingClientRect();

                    requestAnimationFrame(() => {
                        this.$header.addClass('animate-on-transforms');
                        this.$header[0].style.transform = `translate3d(0,0,0)`;
                        this.$header[0].style['-webkit-transform'] = `translate3d(0,0,0)`;

                        setTimeout(()=> {
                            this.$header.removeClass('animate-on-transforms');
                            this.headerClientRect = this.$header[0].getBoundingClientRect();
                            this.navigationAnimationInProgress = false;


                        }, 205);
                    });
                }, 205);
            });
        }
    }

    /**
     *
     */
    myArtemisDropdown() {
        var $helper = $('.ar-myartemis-dropdown-helper');
        var $siteCover = $('.site-cover');
        var self = this;

        function toggle(open) {
            var wasOpen = $('body').hasClass('display-myartemis-dropdown');

            if (open === wasOpen) {
                return false;
            }

            $('body').toggleClass('display-myartemis-dropdown', !wasOpen);
            $('.ar-header-account-arrow__inner').toggleClass('arrrow-up', !wasOpen);

            if (wasOpen) {
                self.deactivateFocusTrap && self.deactivateFocusTrap();
                $(document).off('click focusin', handleOutsideClickOrFocus);
            } else {
                if (localStorage.showDropdownHelper === 'false') {
                    self.deactivateFocusTrap = activateFocusTrap(document.getElementsByClassName('ar-myartemis-dropdown')[0])
                } else {
                    self.deactivateFocusTrap = activateFocusTrap(document.getElementsByClassName('ar-myartemis-dropdown-helper')[0]);
                    $('.ar-myartemis-dropdown-helper__cta').trigger('focus');
                }
                $(document).on('click focusin', handleOutsideClickOrFocus);
            }
            return true;
        }

        function handleOutsideClickOrFocus(e) {
            const wrappingElement = document.getElementsByClassName('ar-header-account-logged-in')[0];

            if (wrappingElement && !wrappingElement.contains(e.target)) {
                toggle(false);
            }
        }

        $('.ar-myartemis-dropdown').on('keydown', (e) => {
            if (e.key !== 'Escape') return true;
            return !toggle(false);
        });

        $('.ar-header-account-badge, .ar-myartemis-link--close').on('click keydown', function(e) {
            if (e.type === 'keydown' && e.key !== 'Enter') return true;
            toggle();
            return false;
        });

        $('.ar-myartemis-dropdown-helper__cta').on('click keypress', function(e) {
            if (e.type === 'keypress' && e.which !== 13) {
                return true;
            }
            localStorage.showDropdownHelper = 'false';
            self.deactivateFocusTrap && self.deactivateFocusTrap();
            $helper.hide();
            $siteCover.hide();
            self.deactivateFocusTrap = activateFocusTrap(document.getElementsByClassName('ar-myartemis-dropdown')[0])
        });

        if (localStorage.showDropdownHelper === 'false') {
            $helper.hide();
            $siteCover.hide();
        }
    }

}


/**
 * Static convenvience method
 */
Navigation.initDefault = function () {
    return new Navigation('.ar-header-primary-nav');
};